import { CapacityUnitLabels, CapacityUnitShortLabels, Equipment } from '@alliance-disposal/transport-types';
/**
 * Derive the ord_ro `requestedType` / `expectedType` value from a container type.
 * ROLL_OFF containers carry their roll-off variant; trailers map to the 'DUMP_TRAILER'
 * variant literal as a catch-all (the order schema only stores a single string here).
 */
export const getOrderTypeFromContainer = (containerType) => containerType.style === 'ROLL_OFF' ? containerType.rollOffVariant : 'DUMP_TRAILER';
export const getContainerTypeName = (containerType) => {
    if (!containerType)
        return 'Equipment';
    if (containerType.style === 'ROLL_OFF') {
        const containerCapacity = `${containerType.capacity} ${CapacityUnitShortLabels[containerType.capacityUnit].toUpperCase()}`;
        const containerVariant = `${Equipment.RollOffVariantLabels[containerType.rollOffVariant]}`;
        const containerRailStyle = `${containerType.rollOffRailStyle ? Equipment.RollOffRailStyleLabels[containerType.rollOffRailStyle] : ''}`;
        const containerLisftStyle = `${containerType.rollOffLiftStyle ? Equipment.RollOffLiftTypeLabels[containerType.rollOffLiftStyle] : ''}`;
        const containerName = `${containerType.name?.trim() ? ` (${containerType.name})` : ''}`;
        return containerCapacity + ' ' + containerVariant + ' ' + containerRailStyle + ' ' + containerLisftStyle + ' ' + containerName;
    }
    return containerType.capacity === 0 // check for loose container type
        ? 'Loose'
        : `${Equipment.ContainerTypeLabels[containerType.style]} - ${containerType.capacity} ${CapacityUnitLabels[containerType.capacityUnit]}${containerType.name?.trim() ? ` (${containerType.name})` : ''}`;
};
//# sourceMappingURL=container-formatter.js.map